module.exports = __webpack_public_path__ + "img/az.2f530702.svg";